import DeleteOperation from "components/tableOperation/DeleteOperation";
import CustomSwitch from "global/Switch/Switch";
import { AiOutlineEdit } from "react-icons/ai";
import {
  FiAlignJustify,
  FiCalendar,
  FiUser,
  FiEdit3,
  FiClock,
  FiLayers,
  FiHelpCircle,
} from "react-icons/fi";
import { hasPermission } from "utils/HasPermission";

type SurveyCardProps = {
  title: string;
  isActive: boolean;
  validFrom: string;
  validTo: string;
  answersCount: number;
  satisfactionPercent: number | null;
  onDetail: () => void;
  onEdit: () => void;
  onChangeStatus: () => void;
  id: number;
  refreshTable: () => void;
  selectSurveyType?: string;
  questionType?: string;
  modifier?: string; // ویرایش کننده
  author?: string; // ایجاد کننده
  createdDate?: string; // تاریخ ایجاد
  modifiedDate?: string; // تاریخ ویرایش
};

export const SurveyCard = ({
  title,
  isActive,
  validFrom,
  validTo,
  answersCount,
  satisfactionPercent,
  onDetail,
  onEdit,
  onChangeStatus,
  id,
  refreshTable,
  selectSurveyType,
  questionType,
  modifier,
  author,
  createdDate,
  modifiedDate,
}: SurveyCardProps) => {
  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4 flex flex-col h-full hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between gap-3">
        <span
          className={`px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${
            isActive
              ? "bg-green-50 text-green-700 border border-green-100"
              : "bg-gray-100 text-gray-600 border border-gray-200"
          }`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              isActive ? "bg-green-500" : "bg-gray-400"
            }`}
          ></span>
          {isActive ? "فعال" : "غیرفعال"}
        </span>

        <div className="flex items-center gap-2">
          {hasPermission("SURVEY_DETAILS_VIEW") && 
          
          <button
            onClick={onDetail}
            className="w-9 h-9 rounded-xl border border-gray-100 hover:bg-brand/10 hover:text-brand hover:border-brand/20 flex items-center justify-center transition-all"
            title="جزئیات"
          >
            <FiAlignJustify size={18} />
          </button>
          }
          {hasPermission("SURVEY_EDIT") && (
            <button
              onClick={onEdit}
              className="w-9 h-9 rounded-xl border border-gray-100 hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200 flex items-center justify-center transition-all"
              title="ویرایش"
            >
              <AiOutlineEdit size={18} />
            </button>
          )}
          {hasPermission("SURVEY_DELETE") && (
            <DeleteOperation
              itemId={id}
              title={"حذف"}
              handleDeleteActionNewData={refreshTable}
              route={"/customer-api/survey/s1/v1/delete"}
            />
          )}
          {hasPermission("SURVEY_STATUS_CHANGE") && (
            <button>
              <CustomSwitch
                active={isActive}
                handleChange={onChangeStatus}
                // handleChange={(event) => handelChangeStatus(event, item)}
                label=""
                wrapperClassName="!mb-0 w-auto"
              />
            </button>
          )}
        </div>
      </div>

      <div className="mt-3 font-bold text-gray-800 line-clamp-2 leading-relaxed">
        {title}
      </div>

      {/* نمایش تگ‌های نوع نظرسنجی و سوال */}
      {(selectSurveyType || questionType) && (
        <div className="mt-3 flex flex-wrap gap-2 text-[11px] font-medium">
          {selectSurveyType && (
            <span className="bg-blue-50 text-blue-600 px-2.5 py-1.5 rounded-lg border border-blue-100 flex items-center gap-1.5">
              <FiLayers size={12} />
              {selectSurveyType}
            </span>
          )}
          {questionType && (
            <span className="bg-purple-50 text-purple-600 px-2.5 py-1.5 rounded-lg border border-purple-100 flex items-center gap-1.5">
              <FiHelpCircle size={12} />
              {questionType}
            </span>
          )}
        </div>
      )}

      {/* تاریخ اعتبار */}
      <div className="mt-4 text-xs text-gray-600 flex items-center gap-2 bg-gray-50 p-2.5 rounded-xl border border-gray-100">
        <FiCalendar className="text-gray-400" size={14} />
        <div className="flex items-center gap-1.5 flex-wrap">
          <span>اعتبار:</span>
          <span className="font-semibold text-gray-800">{validFrom}</span>
          <span className="text-gray-400">تا</span>
          <span className="font-semibold text-gray-800">{validTo}</span>
        </div>
      </div>

      {/* اطلاعات ایجاد و ویرایش */}
      <div className="mt-4 text-[11px] text-gray-500 space-y-2 flex-grow bg-gray-50/50 p-3 rounded-xl">
        {(author || createdDate) && (
          <div className="flex justify-between items-center pb-2 border-b border-gray-100">
            <span className="flex items-center gap-1.5">
              <FiUser size={13} className="text-gray-400" />
              ایجاد کننده:{" "}
              <span className="font-medium text-gray-700">{author || "—"}</span>
            </span>
            <span className="flex items-center gap-1.5">
              <FiCalendar size={13} className="text-gray-400" />
              <span className="font-medium text-gray-700">
                {createdDate || "—"}
              </span>
            </span>
          </div>
        )}
        {(modifier || modifiedDate) && (
          <div className="flex justify-between items-center pt-0.5">
            <span className="flex items-center gap-1.5">
              <FiEdit3 size={13} className="text-gray-400" />
              ویرایش کننده:{" "}
              <span className="font-medium text-gray-700">
                {modifier || "—"}
              </span>
            </span>
            <span className="flex items-center gap-1.5">
              <FiClock size={13} className="text-gray-400" />
              <span className="font-medium text-gray-700">
                {modifiedDate || "—"}
              </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
